import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { useMeta } from "../../../context/MetaContext";

export default function ToolWorkspacePlaceholderPage() {
  const { toolSlug } = useParams();
  const { getToolBySlug, metaLoading } = useMeta();
  const tool = getToolBySlug(toolSlug);

  if (metaLoading) {
    return (
      <main className="page-grid">
        <section className="card-modern">
          <p>Loading workspace configuration...</p>
        </section>
      </main>
    );
  }

  if (!tool) {
    return <Navigate to="/" replace />;
  }

  if (tool.slug === "wpa") {
    return <Navigate to="/tools/wpa/dashboard" replace />;
  }

  return (
    <main className="page-grid">
      <section className="hero-card tool-hero">
        <div>
          <p className="eyebrow">{tool.industry} Workspace</p>
          <h3>{tool.name} Workspace</h3>
          <p>
            This workspace shell is active and reserved for full implementation. You can keep this URL structure and
            expand modules as the feature roadmap matures.
          </p>
          <p className="muted">Workspace path: <strong>{tool.workspacePath}</strong></p>
        </div>
        <div className="hero-actions">
          <Link to={tool.permalink} className="button-link ghost">Back To Tool Landing</Link>
          <Link to="/dashboard" className="button-link">Open Global Dashboard</Link>
        </div>
      </section>

      <section className="content-two-col">
        <article className="card-modern">
          <h4>Planned Modules</h4>
          <ul>
            <li>Context setup and scope definition</li>
            <li>Guided capture for incidents and blockers</li>
            <li>Insight synthesis and recommendation engine</li>
            <li>Stakeholder-ready reporting</li>
          </ul>
        </article>

        <article className="card-modern">
          <h4>Current Status</h4>
          <p>This workspace is intentionally empty for now and ready for feature rollout.</p>
          <p className="muted">Use this as the stable path for future implementation without changing URLs later.</p>
        </article>
      </section>
    </main>
  );
}
